import { gql, useQuery } from "@apollo/client";
import type {
  GetRateAgreementWithRates,
  GetRateAgreementWithRatesVariables
} from "./schema/GetRateAgreementWithRates";

export const getRateAgreementWithRatesQuery = gql`
  query GetRateAgreementWithRates($id: ID!) {
    rates {
      rateAgreementById(rateAgreementId: $id) {
        id
        rateTables {
          id
          name
          type
          currency
          description
          validFrom
          validTo
          useMinimumProcedure
          rateStructure {
            pickupLocationFilters {
              column
              displayName
              operator
            }
            deliveryLocationFilters {
              column
              displayName
              operator
            }
            serviceOptionFilters {
              column
              displayName
              operator
            }
            primaryQuantity {
              column
              unit
              ranges {
                upperBound
                costType
                unitQuantity
              }
            }
            additionalQuantities {
              column
              unit
              ranges {
                upperBound
              }
            }
          }
          rates {
            id
            pickupLocations
            deliveryLocations
            serviceOptions
            charges
          }
        }
      }
    }
  }
`;

export function useRateAgreementWithRates(id: string) {
  const { data, loading, error } = useQuery<
    GetRateAgreementWithRates,
    GetRateAgreementWithRatesVariables
  >(getRateAgreementWithRatesQuery, {
    variables: { id },
    skip: !id
  });
  const rateAgreement = data?.rates?.rateAgreementById ?? null;
  return {
    rateAgreement,
    loading: loading && rateAgreement == null,
    error
  };
}
